const Loader = () =>{
return (
    <div className="loader-parent">
        <h1 className="loader"></h1>
    </div>
)
}

export default Loader;